
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import HUD from '../components/hud'

import {enableHUD, disableHUD} from '../actions/hud'
import {addSpace, switchSpace, updateSpaceName, deleteSpace} from '../actions'

const mapStateToProps = (state) => {
    return {
        hud: state.hud,
        spaces: state.sceneItems.spaces,
        curSpace: state.sceneItems.curSpaceId,
    }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        enableHUD: enableHUD,
        disableHUD: disableHUD,

        addSpace: addSpace,
        switchSpace: switchSpace,
        updateSpaceName: updateSpaceName,
        deleteSpace: deleteSpace,

    }, dispatch);
}

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(HUD);



// WEBPACK FOOTER //
// ./src/containers/hud.js